import React from "react";
import { Link } from "react-router-dom";
import { SiteLayout } from "@/components/SiteLayout";

const monoLabel = { fontFamily: "'DM Mono', monospace", fontSize: 11, letterSpacing: "0.14em", color: "#0891b2", textTransform: "uppercase", marginBottom: 14 };
const h2 = { fontSize: 24, fontWeight: 800, color: "#0c1a2e", letterSpacing: "-0.02em", marginTop: 40, marginBottom: 14 };
const h3 = { fontSize: 17, fontWeight: 700, color: "#0c1a2e", marginTop: 24, marginBottom: 8 };
const p  = { fontSize: 14.5, color: "#3d5166", lineHeight: 1.75, marginBottom: 12 };
const li = { fontSize: 14.5, color: "#3d5166", lineHeight: 1.7, marginBottom: 6 };

export const LegalLayout = ({ eyebrow, title, updated, children }) => (
  <SiteLayout>
    <section style={{ background: "#0c1a2e", padding: "72px 48px" }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <p style={monoLabel}>{eyebrow}</p>
        <h1 style={{ fontSize: 42, fontWeight: 800, letterSpacing: "-0.03em", color: "#fff", lineHeight: 1.1, marginBottom: 14 }}>{title}</h1>
        <p className="font-mono" style={{ fontSize: 11, color: "#5e80a0", letterSpacing: "0.1em", textTransform: "uppercase" }}>Last updated · {updated}</p>
      </div>
    </section>
    <section style={{ background: "#fff", padding: "56px 48px" }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <div style={{ background: "rgba(217,119,6,0.06)", border: "1px solid rgba(217,119,6,0.25)", borderRadius: 10, padding: "14px 18px", marginBottom: 32 }}>
          <p style={{ fontSize: 13, color: "#7c2d12", lineHeight: 1.65 }}>
            <strong>Legal disclaimer.</strong> This document sets out the legal framework governing your use of ARGOV™ services. It does not constitute legal, regulatory, or compliance advice. You should obtain independent professional advice before relying on any information provided herein.
          </p>
        </div>
        {children}
        <div style={{ marginTop: 48, padding: "20px 22px", background: "#f8fafc", border: "1px solid #e2eaf2", borderRadius: 10 }}>
          <p style={{ fontSize: 13, color: "#4a6070", lineHeight: 1.65 }}>
            For legal questions, notices, or data-subject requests, contact <a href="mailto:legal@argov.ai" style={{ color: "#0891b2" }}>legal@argov.ai</a>. You may also review our <Link to="/privacy" style={{ color: "#0891b2" }}>Privacy Policy</Link>, <Link to="/terms" style={{ color: "#0891b2" }}>Terms of Service</Link>, <Link to="/legal" style={{ color: "#0891b2" }}>Legal Notice</Link>, and <Link to="/cookies" style={{ color: "#0891b2" }}>Cookie Policy</Link>.
          </p>
        </div>
      </div>
    </section>
  </SiteLayout>
);

export const S = { monoLabel, h2, h3, p, li };
